// removed by extract-text-webpack-plugin
module.exports = {"button":"_1JxkiVlzkTj09nwo","content":"_1Ib43gT-Pni5_Udd","facebook":"VK4ObjcVnVIW0hFR","facebookSmall":"LSns4l0gCQeWxNvI","twitter":"_1JUQjBlvexeERu0-","small":"tn7rMMPBceOWoire","light":"_3FBT7a4LfTBN8vC0","loading":"_2_r4Qedbc7KxmtrI","spinner":"_29AlFeTD7BtP6jcc"};


//////////////////
// WEBPACK FOOTER
// ./app/components/Common/Button.pcss
// module id = 464
// module chunks = 1